import type { IMainNewsItemDataClientDTO } from '../api/client/main-news/main-news.dto';

export const useMainNewsList = () =>
  useState<IMainNewsItemDataClientDTO[]>('mainNewsList', () => []);

export const useMainNewsSelected = () =>
  useState<IMainNewsItemDataClientDTO | null>('mainNewsSelected', () => null);
